import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import FractionNodeView from './FractionNodeView';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        fraction: {
            insertFraction: (attrs?: {
                numerator?: string;
                denominator?: string;
            }) => ReturnType;
        };
    }
}

export const FractionExtension = Node.create({
    name: 'fraction',
    group: 'inline',
    inline: true,
    atom: true,

    addAttributes() {
        return {
            numerator: { default: '' },
            denominator: { default: '' },
        };
    },

    parseHTML() {
        return [{ tag: 'span[data-type="fraction"]' }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'span',
            mergeAttributes(HTMLAttributes, { 'data-type': 'fraction' }),
        ];
    },

    addCommands() {
        return {
            insertFraction:
                (attrs = {}) =>
                ({ commands }) =>
                    commands.insertContent({
                        type: this.name,
                        attrs: { numerator: '', denominator: '', ...attrs },
                    }),
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(FractionNodeView);
    },
});
